import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import toast from "components/shared/toast/toast";
import { LOCATION } from "services/apiEndpoints";
import { privateDelete, privateGet } from "services/privateRequest";
import { makeQueryString } from "utils/utils";

const initialState = {
    totalLocations: 0,
    selectedLocations: null,
    locationsModalOpen: false,
    isFetching: false,
    allLocations: [],
    filterValues: {},

    locations: [],
    pageNumber: 1,
    pageSize: 10,
    totalCount: 0,
    filters: {
        selectedTeam: { label: "", value: "" },
    }
}


export const getLocationsData = createAsyncThunk("locations/getLocationsData", async (payload, { rejectWithValue, dispatch, signal }) => {

    try {
        const queryString = makeQueryString(LOCATION, payload);

        const { data } = await privateGet(queryString, { signal });

        dispatch(setPageNumber(payload.pageNumber));
        dispatch(setPageSize(payload.limit));
        return {
            location: data?.data?.location || [],
            totalCount: data?.data?.totalLocations || 0,
        };
    } catch (error) {
        rejectWithValue(error);
        return error;
    }
})

export const getAllLocationsData = createAsyncThunk("locations/getAllLocationsData", async () => {
    const res = await privateGet(LOCATION)
    return {
        data: res?.data?.data || [],
    }
})

export const deleteLocations = createAsyncThunk("locations/deleteLocations", async (id, { dispatch }) => {
    await privateDelete(LOCATION, id)
    dispatch(getLocationsData())
    toast.success("Locations deleted successfully")
})

const locationsSlice = createSlice({
    name: "locations",
    initialState,
    reducers: {
        setPageNumber: (state, action) => {
            state.pageNumber = action.payload;
        },
        setPageSize: (state, action) => {
            state.pageSize = action.payload;
            state.pageNumber = 1;
        },
        setIsFetching: (state, action) => {
            state.isFetching = action.payload
        },
        setSelectedLocations: (state, action) => {
            state.selectedLocations = action.payload
            state.locationsModalOpen = !!action.payload
        },
        setLocationsModalOpen: (state, action) => {
            state.locationsModalOpen = action.payload
        },
        setFilterValues: (state, action) => {
            state.filterValues = action.payload
        },
        setSelectedTeamFilter: (state, action) => {
            if (!action.payload) {
                state.filters.selectedTeam = { label: "", value: "" };
            }
            else { state.filters.selectedTeam = action.payload; }
        },
    },
    extraReducers: {
        [getLocationsData.pending]: (state, action) => {
            state.isFetching = true
        },
        [getLocationsData.fulfilled]: (state, action) => {
            state.locations = action.payload.location
            state.totalCount = action.payload.totalCount
            state.isFetching = false
        },
        [getLocationsData.rejected]: (state, action) => {
            state.isFetching = false
        },
    }
})

export default locationsSlice.reducer
export const { setIsFetching, setSelectedTeamFilter, setPageNumber, setPageSize, setSelectedLocations, setLocationsModalOpen, setFilterValues } = locationsSlice.actions